import { Link } from "react-router-dom";
import { Sparkles, Zap } from "lucide-react";
import { daysLeft } from "@/components/ProTrial";

export const QUESTIONS = [
  { key: "budget", label: "Budget iniziale", options: ["€0 - 500", "€500 - 2.000", "€2.000 - 10.000", "Oltre €10.000"] },
  { key: "tempo", label: "Tempo disponibile", options: ["5-10 ore/settimana", "10-20 ore/settimana", "Full-time"] },
  { key: "modalita", label: "Dove vuoi lavorare", options: ["Online", "Offline / locale", "Ibrido"] },
  { key: "rischio", label: "Livello di rischio", options: ["Basso", "Medio", "Alto"] },
];

const ChipGroup = ({ q, value, onChange }) => (
  <div>
    <div className="text-sm font-medium text-slate-300 mb-3">{q.label}</div>
    <div className="flex flex-wrap gap-2">
      {q.options.map((o, i) => (
        <button key={o} type="button" onClick={() => onChange(value === o ? null : o)} data-testid={`q-${q.key}-option-${i}`}
          className={`rounded-full border px-4 py-2 text-sm transition-colors duration-200 ${value === o ? "bg-amber-500 border-amber-500 text-slate-950 font-semibold" : "border-white/10 text-slate-300 hover:border-amber-500/50 hover:text-slate-100"}`}>
          {o}
        </button>
      ))}
    </div>
  </div>
);

export const Questionnaire = ({ form, setForm }) => (
  <>
    {QUESTIONS.map((q) => (
      <ChipGroup key={q.key} q={q} value={form[q.key]} onChange={(v) => setForm({ ...form, [q.key]: v })} />
    ))}
    <div>
      <div className="text-sm font-medium text-slate-300 mb-3">Interessi e competenze</div>
      <input value={form.interessi} onChange={(e) => setForm({ ...form, interessi: e.target.value })} data-testid="q-interessi-input"
        placeholder="Es. cucina, fotografia, ho lavorato in banca, mi piacciono gli animali…"
        className="w-full rounded-xl bg-[#090A0F] border border-white/10 px-4 py-3 text-sm text-slate-100 placeholder:text-slate-600 outline-none focus:border-amber-500/60 transition-colors" />
    </div>
  </>
);

const usageLabel = (usage) => {
  if (!usage.pro) return `${Math.min(usage.used, usage.limit)}/${usage.limit} generazioni gratuite oggi`;
  return usage.trial_ends_at ? `Prova Pro · ${daysLeft(usage.trial_ends_at)} giorni rimasti` : "Pro · generazioni illimitate";
};

export const GenerateActions = ({ run, loading, disabled, usage }) => (
  <div className="flex flex-wrap items-center gap-3 pt-2">
    <button onClick={() => run(false)} disabled={loading || disabled} data-testid="btn-generate-ideas"
      className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-6 py-3 font-semibold text-slate-950 transition-colors duration-200 hover:bg-amber-400 disabled:opacity-50">
      <Sparkles className="w-4 h-4" /> {loading ? "Generazione in corso…" : "Genera 3 idee"}
    </button>
    <button onClick={() => run(true)} disabled={loading || disabled} data-testid="btn-skip-questionnaire"
      className="inline-flex items-center gap-2 rounded-full border border-white/15 px-6 py-3 font-semibold text-slate-200 transition-colors duration-200 hover:border-amber-500/60 hover:text-amber-300 disabled:opacity-50">
      <Zap className="w-4 h-4" /> Salta: le più redditizie
    </button>
    {usage && <span className="ml-auto text-xs font-mono text-slate-500" data-testid="usage-counter">{usageLabel(usage)}</span>}
  </div>
);

export const LimitBanner = () => (
  <div className="rounded-2xl border border-amber-500/30 bg-amber-500/[0.07] p-5 flex flex-wrap items-center justify-between gap-4" data-testid="limit-reached-banner">
    <p className="text-sm text-slate-200">Hai usato le 3 generazioni gratuite di oggi. Torna domani oppure prova Pro gratis per 7 giorni, senza carta.</p>
    <div className="flex flex-wrap gap-2">
      <Link to="/pro#prova" data-testid="limit-trial-btn" className="rounded-full bg-emerald-400 px-5 py-2.5 text-sm font-semibold text-slate-950 hover:bg-emerald-300 transition-colors">Prova Pro gratis 7 giorni</Link>
      <Link to="/pro" data-testid="limit-upgrade-btn" className="rounded-full border border-white/15 px-5 py-2.5 text-sm font-semibold text-slate-200 hover:border-amber-500/60 hover:text-amber-300 transition-colors">Passa a Pro</Link>
    </div>
  </div>
);
